<template>
  <div class="dropzone-container">
    <label class="input-file" @drop.prevent="handleDrop" @dragover.prevent>
      <input
        data-external="files-add-modal-dropzone-file-input"
        type="file"
        multiple
        :accept="acceptedFileTypes"
        @change="handleSelect"
      />
      <DefaultImageIllustration class="file-icon" />
      <FriedH3 class="drag-and-drop-text">
        {{ t('dr_content_upload_drag_and_drop') }} <u>{{ t('dr_browse_to_choose_file_link') }}</u>
      </FriedH3>
      <FriedParagraph v-if="isUploadRestricted" :size="ParagraphSize.Small" class="support-text">{{
        maximumFileSizeString
      }}</FriedParagraph>
    </label>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue';
import DefaultImageIllustration from '@getaccept/lib-shared-new/src/assets/image-file.svg';
import { allAcceptedFileTypes } from '@getaccept/dsr-shared-new/src/files/constants/accepted-file-types';
import { useI18n } from 'vue-i18n';
import { ParagraphSize } from '@getaccept/fried-tofu';
import { FileHelper } from '../helpers/file.helper';

export default defineComponent({
  components: {
    DefaultImageIllustration,
  },
  props: {
    isUploadRestricted: {
      type: Boolean,
    },
    fileSizeLimit: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const maximumFileSizeString = computed(
      () => `${t('dr_files_maximum_size')} ${FileHelper.formatSize(props.fileSizeLimit)}.`
    );
    const handleDrop = (event: DragEvent) => {
      const inputElement = event.target as HTMLInputElement;
      inputElement.value = '';

      if (!event.dataTransfer || !event.dataTransfer.files.length) {
        return;
      }

      handleFiles(event.dataTransfer.files);
    };

    const handleSelect = (event: Event) => {
      const { files } = event.target as HTMLInputElement;
      if (!files || !files.length) {
        return;
      }
      handleFiles(files);
    };

    const handleFiles = (files: FileList) => {
      for (var i = 0; i < files.length; i++) {
        emit('add-file', files[i]);
      }
    };

    const acceptedFileTypes = computed(() => allAcceptedFileTypes.join(','));

    return {
      handleDrop,
      handleSelect,
      handleFiles,
      acceptedFileTypes,
      maximumFileSizeString,

      t,
      ParagraphSize,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/lib-shared-new/src/assets/scss/dropzone';

.file-icon {
  margin-bottom: 0;
}

.dropzone-container {
  padding: var(--spacing-100);
}
</style>
